import { Component, ElementRef, ViewChild, OnInit, Compiler} from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import 'rxjs/add/operator/filter';
import { GridOptions } from "ag-grid";
import { ConsigmentUploadService } from 'app/d2z/service/consignment-upload.service';
import { TrackingDataService } from 'app/d2z/service/tracking-data.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { E } from '@angular/core/src/render3';
declare var $: any;

interface dropdownTemplate {
  name: string;
  value: string;
}

@Component({
  selector: 'scan-shipment',
  templateUrl: './scan-shipment.component.html',
  styleUrls: ['./scan-shipment.component.css']
})
export class SuperuserScanShipmentComponent implements OnInit{
  shipmentScanForm: FormGroup;
  childmenu: boolean;
  childmenuTwo:boolean;
  childmenuThree:boolean;
  childmenuFour:boolean;
  childmenuFive:boolean;
  showShipmentNumber: boolean;
  manifestNumber: string;
  errorMsg: string;
  successMsg: String;
  show: Boolean;
  showAllocate: Boolean;
  showByPassRCVMEL: Boolean;
  userName: String;
  role_id: String;
  ManifestArray: dropdownTemplate[];  
  selectedManifest: dropdownTemplate;
  constructor(
    public consigmentUploadService: ConsigmentUploadService,
    public trackingDataService : TrackingDataService,
    private spinner: NgxSpinnerService,
    private _compiler: Compiler
  ) {
    this.show = false;
    this._compiler.clearCache();
    this.shipmentScanForm = new FormGroup({
      identifier: new FormControl('referenceNumber'),
      referenceNumber: new FormControl(),
      shipmentNumber: new FormControl(""),
      function: new FormControl('allocateShipment')
    });
  }

  ngOnInit() {
      this.getLoginDetails();
      var role = this.consigmentUploadService.userMessage.role_Id;
      if(role==14){
        this.showAllocate = false;
        this.showByPassRCVMEL = false;
        this.onFunctionChange('sendToSupplier');
        this.shipmentScanForm.controls['function'].setValue('sendToSupplier');
      }else{
        this.showAllocate = true;
        this.showByPassRCVMEL = true;
        this.onFunctionChange('allocateShipment');
      }
  };

  getLoginDetails(){
    if(this.consigmentUploadService.userMessage != undefined){
      this.userName = this.consigmentUploadService.userMessage.userName;
      this.role_id = this.consigmentUploadService.userMessage.role_Id;
    }
  };

  onFunctionChange(func){
   // let func = e.target.value;
   console.log(func)
    if(func == 'sendToSupplier'){

      this.showShipmentNumber = false;
      this.shipmentScanForm.value.shipmentNumber = "SN";
    }else{
      this.showShipmentNumber=true;
      this.shipmentScanForm.value.shipmentNumber=(this.shipmentScanForm.value.shipmentNumber=='SN')?"":this.shipmentScanForm.value.shipmentNumber;
    }
  }

  scanShipment(){
    let func = this.shipmentScanForm.controls['function'].value;
    if(func == 'updateAirwayBill'){
      this.updateAirwayBill();
    }else{
    console.log("Shipment Clicked")
    this.errorMsg = null;
    this.successMsg = null;
    console.log(this.shipmentScanForm.value.shipmentNumber)
    if(this.showShipmentNumber && (this.shipmentScanForm.value.shipmentNumber == null || this.shipmentScanForm.value.shipmentNumber == '')){
      this.errorMsg = "**Please Enter the Shipment Number";
    }
    if(this.shipmentScanForm.value.referenceNumber == null || this.shipmentScanForm.value.referenceNumber == ''){
      this.errorMsg = "**Please Enter the Reference Number";
    }
    if(!this.showShipmentNumber){
      this.shipmentScanForm.value.shipmentNumber = "SN";
    }
    if(this.errorMsg == null ){
      var referenceNumberData = this.shipmentScanForm.value.referenceNumber.split("\n");
      var refrenceNumList = referenceNumberData.join(',');
        this.spinner.show();
        this.trackingDataService.scanToShipment(refrenceNumList, this.shipmentScanForm.value.shipmentNumber, 
          this.shipmentScanForm.value.identifier,this.shipmentScanForm.value.function , (resp) => {
          this.spinner.hide();
        //  if(resp.error){
          //  this.errorMsg = resp.error.errorDetails;
          //}else{
            this.successMsg = "Shipment allocated successfully";
          //}
          this.shipmentScanForm.reset();
          $('#scanShipmentModal').modal('show');
          setTimeout(() => {
            this.spinner.hide();
          }, 5000);
        });
 
      /*  if(this.shipmentScanForm.value.identifier == 'referenceNumber'){
        this.trackingDataService.shipmentAllocation(refrenceNumList, this.shipmentScanForm.value.shipmentNumber, (resp) => {
          this.spinner.hide();
        //  if(resp.error){
          //  this.errorMsg = resp.error.errorDetails;
          //}else{
            this.successMsg = "Shipment allocated successfully";//resp.responseMessage;
          //}
          $('#scanShipmentModal').modal('show');
          setTimeout(() => {
            this.spinner.hide();
          }, 5000);
        });
      }
      else{
        this.trackingDataService.shipmentAllocationArticleID(refrenceNumList, this.shipmentScanForm.value.shipmentNumber, (resp) => {
          this.spinner.hide();
          if(resp.error){
            this.errorMsg = resp.error.errorDetails;
          }else{
            this.successMsg = resp.responseMessage;
          }
          $('#scanShipmentModal').modal('show');
          setTimeout(() => {
            this.spinner.hide();
          }, 5000);
        });
 
      }*/
    }
  }
  }
  updateAirwayBill(){
    this.errorMsg = null;
    this.successMsg = null;
    console.log(this.shipmentScanForm.value.shipmentNumber)
    console.log( this.shipmentScanForm.value.identifier)
    if(this.showShipmentNumber && (this.shipmentScanForm.value.shipmentNumber == null || this.shipmentScanForm.value.shipmentNumber == '')){
      this.errorMsg = "**Please Enter the Shipment Number";
    }
    if(this.shipmentScanForm.value.referenceNumber == null || this.shipmentScanForm.value.referenceNumber == ''){
      this.errorMsg = "**Please Enter the Reference Number";
    }
    if(this.errorMsg == null ){
      var referenceNumberData = this.shipmentScanForm.value.referenceNumber.split("\n");
      var refrenceNumList = referenceNumberData.join(',');
        this.spinner.show();
        this.trackingDataService.updateAirwayBill(refrenceNumList, this.shipmentScanForm.value.shipmentNumber, 
          "referenceNumber", (resp) => {
          this.spinner.hide();
          if(resp.status == 200){
         
            this.successMsg = "Airway Bill updated successfully";
          }else{
            this.errorMsg = "Unable to update AirwayBill";
          }
          $('#scanShipmentModal').modal('show');
          setTimeout(() => {
            this.spinner.hide();
          }, 5000);
        });
  }
}

}



// WEBPACK FOOTER //
// ./src/app/d2z/views/superuser-level/create-shipment/scan-shipment/scan-shipment.component.ts